/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react'
import PropTypes from 'prop-types'
// @material-ui/core components
import withStyles from '@material-ui/core/styles/withStyles'
import InputLabel from '@material-ui/core/InputLabel'

// @material-ui/icons
import Event from '@material-ui/icons/Event'
import Modal from '../../components/feedback/modal'
import { Form, Input, Switch, Upload, InputNumber, Row, Col, Avatar } from 'antd'
import { FaCheck, FaTimes, FaPlus, FaSave, FaEdit } from 'react-icons/fa'

import moment from 'moment'

// core components
import GridContainer from '../../componentsMaterial/Grid/GridContainer.jsx'
import GridItem from '../../componentsMaterial/Grid/GridItem.jsx'
import CustomInput from '../../componentsMaterial/CustomInput/CustomInput.jsx'
import Clearfix from '../../componentsMaterial/Clearfix/Clearfix.jsx'
import Card from '../../componentsMaterial/Card/Card.jsx'
import CardBody from '../../componentsMaterial/Card/CardBody.jsx'
import CardHeader from '../../componentsMaterial/Card/CardHeader.jsx'
import CardIcon from '../../componentsMaterial/Card/CardIcon.jsx'
import ImageUpload from '../../componentsMaterial/CustomUpload/ImageUpload.jsx'
import scrumBoardActions from '../../redux/scrumBoard/actions'

import Datetime from 'react-datetime'
import AddIcon from '@material-ui/icons/Add'
import ContentHolder from '../../components/utility/contentHolder'
import Fab from '@material-ui/core/Fab'
import Button from '../../components/uielements/button'
import Popover from '../../components/uielements/popover'
import { notification } from 'antd'

import userProfileStyles from './userProfileStyles'
// redux
import { connect } from 'react-redux'
import authActions from '../../redux/auth/actions'
import eventActions from '../../redux/event/actions'

import Tags from '../../components/uielements/tag'
import TagWrapper from './tag.style'
import { Alert } from 'antd'
import image from '../../resource/image/imgEventDefaul.jpg'
import Tooltip from '@material-ui/core/Tooltip'
import defaultImgEvent from '../../resource/image/imgEventDefaul.jpg'
import objectDefault from '../../resource/image/objectDefault.png'
import SelectMediaComponent from '../../components/select_medias'
import SelectObjectComponent from '../../components/select_objects'
const Tag = props => (
    <TagWrapper>
        <Tags {...props}>{props.children}</Tags>
    </TagWrapper>
)
const seconds = new Date().getTime() / 1000

class ContentCreateEvent extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            timeStart: seconds,
            time_end: seconds + 604800, // cong 1 tuan`
            content: '',
            name: '',
            address: '',
            visible: false,
            visibleDelete: false,
            TagAdd: '',
            currentTag: '',
            lstTag: [],
            nameState: '',
            contentstate: '',
            countExtend: 0,
            extendIndex: [],
            extendKey: [],
            extendData: [],
            extendKeyErr: [],
            extendDataErr: [],
            isEdit: [],
        }
        this.imgUpload = React.createRef()
    }
    componentDidMount() { }

    handleSimple = event => {
        this.setState({ organ_id: event.target.value })
    }
    getRandomInt = max => {
        return Math.floor(Math.random() * Math.floor(max))
    }

    getColorTag = () => {
        const color = [
            '#f50',
            '#2db7f5',
            '#87d068',
            '#108ee9',
            '#e6f542',
            '#f54242',
        ]
        const index = this.getRandomInt(color.length)

        return color[index]
    }
    validationTimeEnd = currentDate => {
        return currentDate.isAfter(moment(this.state.timeStart * 1000))
    }
    validationTimeStart = currentDate => {
        return currentDate.isBefore(moment(this.state.time_end * 1000))
    }
    submitForm = lstTag => {
        const { updateEvent, currentEvent } = this.props
        const { timeStart, time_end, content, name, address } = this.state
        if (name === '') {
            this.setState({ nameState: 'error' })
        } else if (content === '') {
            this.setState({ contentstate: 'error' })
        } else {
            this.setState({ nameState: 'success', contentstate: 'success' })
            let data = {
                begin_time: parseInt(timeStart, 10),
                end_time: parseInt(time_end, 10),
                content: content,
                name: name,
                avatar:
                    this.imgUpload.current.getUrlUpload() !== null
                        ? this.imgUpload.current.getUrlUpload()
                        : '',
                hashtag: lstTag,
                address: address,
            }
            console.log('data create event', data)
            const lstExtData = []
            let error = true
            this.state.extendIndex.map(index => {
                if (this.state.extendKey[index] && this.state.extendKey[index].trim() === '') {
                    error = false
                    let errkey = this.state.extendKeyErr
                    errkey[index] = false
                    this.setState({ extendKeyErr: errkey })
                }
                if (this.state.extendData[index].trim() === '') {
                    error = false
                    let errData = this.state.extendDataErr
                    errData[index] = false
                    this.setState({ extendKeyErr: errData })
                }
                const newData = {
                    label: this.state.extendKey[index],
                    data: this.state.extendData[index],
                }
                lstExtData.push(newData)
            })
            let obj_id = []
            let media_id = []
            this.props.ListCurrentObject.map(vl => {
                obj_id.push(vl.object_id)
            })
            this.props.ListCurrentMedia.map(vl => {
                media_id.push(vl.media_id)
            })
            data = { ...data, ext_data: { lstExtendData: JSON.stringify(lstExtData), obj_ids: JSON.stringify(obj_id), media_ids: JSON.stringify(media_id) } }

            if (error) {
                this.props.createNewEvent(data)
            }
        }


    }
    _userSelectMedia = medias => {
        console.log('medias : ', medias)
        this.props.showModalMedia(false)
        this.props.applyToMedia([])
        this.props.applyToMedia(medias)
    }
    _userSelectObject = objects => {
        this.props.showModalObject(false)
        this.props.applyToCurrentObject([])
        this.props.applyToCurrentObject(objects)
    }
    componentWillUnmount() {
        this.props.applyToMedia([])
        this.props.applyToCurrentObject([])

    }
    _handleAddExtendData = () => {
        const crrIndex = this.state.extendIndex.concat(this.state.countExtend)
        const crrKey = this.state.extendKey.concat('')
        const crrData = this.state.extendData.concat('')
        const crrDataErr = this.state.extendDataErr.concat(true)
        const crrKeyErr = this.state.extendKeyErr.concat(true)
        const isEdit = this.state.isEdit.concat(true)

        this.setState({
            extendIndex: crrIndex,
            countExtend: this.state.countExtend + 1,
            extendKey: crrKey,
            extendData: crrData,
            extendDataErr: crrDataErr,
            extendKeyErr: crrKeyErr,
            isEdit: isEdit,
        })
    }
    _handleDeleteIExtData = index => {
        const crrIndex = this.state.extendIndex
        crrIndex.splice(index, 1)
        const crrKey = this.state.extendKey
        crrKey.splice(index, 1)

        const crrData = this.state.extendData
        crrData.splice(index, 1)

        const crrDataErr = this.state.extendDataErr
        crrDataErr.splice(index, 1)

        const crrKeyErr = this.state.extendKeyErr
        crrKeyErr.splice(index, 1)

        const isEdit = this.state.isEdit
        isEdit.splice(index, 1)

        this.setState({
            extendIndex: crrIndex,
            countExtend: this.state.countExtend - 1,
            extendKey: crrKey,
            extendData: crrData,
            extendDataErr: crrDataErr,
            extendKeyErr: crrKeyErr,
            isEdit: isEdit,
        })
    }

    render() {
        const { classes } = this.props
        const { userInfo, currentEvent } = this.props
        const { lstTag, nameState } = this.state
        console.log('current event', this.props)
        const formExtendData = Array.isArray(this.state.extendIndex)
            ? this.state.extendIndex.map((value, index) => (
                <div style={{ padding: 15, width: '100%' }}>
                    <Row>
                        <Col
                            style={{
                                display: 'flex',
                                marginRight: 15
                            }}
                            span={7}
                        >
                            {' '}
                            {this.state.isEdit[index] && (
                                <div
                                    style={{
                                        display: 'flex',
                                        flexDirection: 'column',
                                    }}
                                >
                                    <Input
                                        style={{
                                            //   width: 150,
                                            marginRight: 15,
                                            alignItems: 'center',
                                        }}
                                        onChange={value => {
                                            let datakey = this.state.extendKey
                                            datakey[index] =
                                                value.target.value
                                            this.setState({
                                                extendKey: datakey,
                                            })
                                        }}
                                        defaultValue={
                                            this.state.extendKey[index]
                                        }
                                        placeholder="Tên trường dữ liệu"
                                    />
                                    {!this.state.extendKeyErr[index] && (
                                        <text
                                            style={{
                                                color: 'red',
                                                fontSize: 13,
                                            }}
                                        >
                                            Mời nhập tên trường dữ liệu
                                        </text>
                                    )}
                                </div>
                            )}
                            {!this.state.isEdit[index] && (
                                <text
                                    style={{
                                        marginRight: 15,
                                        alignItems: 'center',
                                        paddingTop: 4,
                                    }}
                                >
                                    {this.state.extendKey[index]} :
                                </text>
                            )}
                        </Col>
                        <Col
                            span={15}
                            style={{
                                display: 'flex',
                                flexDirection: 'row',
                                alignItems: 'center',
                                justifyItems: 'center',
                            }}
                        >
                            <div
                                style={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    width: '100%',
                                }}
                            >
                                <Input
                                    placeholder="Thông tin"
                                    defaultValue={
                                        this.state.extendData[index]
                                    }
                                    onChange={value => {
                                        let data = this.state.extendData
                                        data[index] = value.target.value
                                        this.setState({ extendData: data })
                                    }}
                                    style={{ width: '95%' }}
                                />
                                {!this.state.extendDataErr[index] && (
                                    <text
                                        style={{ color: 'red', fontSize: 13 }}
                                    >
                                        Hãy nhập thông tin này
                                    </text>
                                )}
                            </div>
                            <FaEdit
                                size={20}
                                style={{ paddingLeft: 4, cursor: 'pointer' }}
                                onClick={() => {
                                    let isEdit = this.state.isEdit
                                    isEdit[index] = true
                                    this.setState({ isEdit: isEdit })
                                }}
                            />
                            <FaTimes
                                size={15}
                                style={{ paddingLeft: 4, cursor: 'pointer' }}
                                onClick={() => {
                                    this._handleDeleteIExtData(index)
                                }}
                            />
                        </Col>
                    </Row>
                </div>
            ))
            : null
        return (
            <div>
                <GridContainer>
                    <GridItem xs={12} sm={12} md={12}>
                        <Card>
                            <CardHeader color="info" icon>
                                <CardIcon color="rose">
                                    <Event />
                                </CardIcon>
                                <h4 className={classes.cardIconTitle}>
                                    Thông tin sự kiện
                                </h4>
                            </CardHeader>
                            <CardBody>
                                <GridContainer>
                                    <GridItem xs={12} sm={12} md={4}>
                                        <Card plain>
                                            <ImageUpload
                                                ref={this.imgUpload}
                                                avatar={image}
                                                addButtonProps={{
                                                    color: 'info',
                                                    round: true,
                                                    size: 'sm',
                                                }}
                                            />
                                            {/* </CardAvatar> */}
                                            <CardBody formHorizontal></CardBody>
                                        </Card>
                                    </GridItem>
                                    <GridContainer xs={12} sm={12} md={7}>
                                        <GridItem xs={12} sm={12} md={12}>
                                            <CustomInput
                                                success={
                                                    nameState === 'success'
                                                }
                                                error={nameState === 'error'}
                                                labelText="Tên sự kiện *"
                                                id="about-me"
                                                formControlProps={{
                                                    fullWidth: true,
                                                }}
                                                inputProps={{
                                                    onChange: e =>
                                                        this.setState({
                                                            name: e.target.value.trim(),
                                                        }),
                                                    multiline: true,
                                                }}
                                            />
                                        </GridItem>

                                        <GridItem xs={12} sm={12} md={12}>
                                            <InputLabel
                                                className={classes.label}
                                                style={{ fontSize: 15 }}
                                            >
                                                Thời gian bắt đầu
                                            </InputLabel>
                                            <Datetime
                                                isValidDate={
                                                    this.validationTimeStart
                                                }
                                                timeFormat={false}
                                                value={moment(
                                                    this.state.timeStart * 1000
                                                ).format('DD/MM/YYYY')}
                                                closeOnSelect
                                                onChange={e =>
                                                    this.setState({
                                                        timeStart:
                                                            e._d.valueOf() /
                                                            1000,
                                                    })
                                                }
                                                inputProps={{
                                                    placeholder:
                                                        'Thời gian bắt đầu',
                                                    readOnly: true,
                                                }}
                                            />
                                        </GridItem>
                                        <GridItem xs={12} sm={12} md={12}>
                                            <InputLabel
                                                className={classes.label}
                                                style={{
                                                    paddingTop: 10,
                                                    fontSize: 15,
                                                }}
                                            >
                                                Thời gian kết thúc
                                            </InputLabel>

                                            <Datetime
                                                isValidDate={
                                                    this.validationTimeEnd
                                                }
                                                timeFormat={false}
                                                strictParsing
                                                value={moment(
                                                    this.state.time_end * 1000
                                                ).format('DD/MM/YYYY')}
                                                closeOnSelect
                                                onChange={e =>
                                                    this.setState({
                                                        time_end:
                                                            e._d.valueOf() /
                                                            1000,
                                                    })
                                                }
                                                inputProps={{
                                                    placeholder:
                                                        'Thời gian kết thúc',
                                                    readOnly: true,
                                                }}
                                            />
                                        </GridItem>
                                        <GridItem xs={12} sm={12} md={12}>
                                            <CustomInput
                                                labelText="Địa điểm diễn ra "
                                                formControlProps={{
                                                    fullWidth: true,
                                                }}
                                                inputProps={{
                                                    onChange: e =>
                                                        this.setState({
                                                            address:
                                                                e.target.value,
                                                        }),
                                                    multiline: true,
                                                }}
                                            />
                                        </GridItem>
                                        {formExtendData}
                                        <GridItem xs={12} sm={12} md={12}>
                                            <InputLabel
                                                className={classes.label}
                                            >
                                                HashTag
                                            </InputLabel>
                                            <ContentHolder>
                                                {lstTag.map(value => (
                                                    <Popover
                                                        content={
                                                            <a
                                                                onClick={() => {
                                                                    for (
                                                                        let i = 0;
                                                                        i <
                                                                        lstTag.length;
                                                                        i++
                                                                    ) {
                                                                        if (
                                                                            lstTag[
                                                                            i
                                                                            ] ===
                                                                            value
                                                                        ) {
                                                                            lstTag.splice(
                                                                                i,
                                                                                1
                                                                            )
                                                                        }
                                                                    }
                                                                    this.setState(
                                                                        {
                                                                            visibleDelete: false,
                                                                        }
                                                                    )
                                                                }}
                                                            >
                                                                Xoá hashtag này
                                                            </a>
                                                        }
                                                        trigger="click"
                                                        // visible={
                                                        //     value ===
                                                        //     this.state
                                                        //         .currentTag
                                                        // }
                                                        onVisibleChange={e =>
                                                            this.setState({
                                                                visibleDelete: e,
                                                            })
                                                        }
                                                    >
                                                        <Tag
                                                            color={this.getColorTag()}
                                                            onClick={() => {
                                                                this.setState({
                                                                    currentTag: value,
                                                                })
                                                            }}
                                                        >
                                                            {value}
                                                        </Tag>
                                                    </Popover>
                                                ))}
                                                <Fab
                                                    aria-label="add"
                                                    size="small"
                                                    color="secondary"
                                                    onClick={() =>
                                                        this.setState({
                                                            visible: true,
                                                        })
                                                    }
                                                >
                                                    <AddIcon />
                                                </Fab>
                                            </ContentHolder>
                                        </GridItem>
                                    </GridContainer>
                                </GridContainer>
                                <Row style={{ marginLeft: 10, color: 'white', marginRight: 10, marginTop: 15 }}>
                                    <Col span={8} />
                                    <Col
                                        span={7}
                                        style={{ display: 'flex', flexDirection: 'column' }}
                                    >
                                        <text style={{ color: 'black', fontWeight: '600', fontSize: 15 }}>Tài liệu liên quan</text>
                                        {this.props.ListCurrentMedia.map(media => (
                                            <a
                                                type="link"
                                                // href={media.url}
                                                target="_blank"
                                                onClick={() => {
                                                    window.open(media.url, '_blank')
                                                }}
                                                block={false}
                                                style={{
                                                    paddingLeft: 5,
                                                    color: '#1a73e8',
                                                    textDecorationLine: 'underline',
                                                    paddingRight: 10,
                                                }}
                                            >
                                                {media.name}
                                            </a>
                                        ))}
                                        <Button
                                            type="primary"
                                            icon="upload"
                                            onClick={() => this.props.showModalMedia(true)}
                                            style={{
                                                width: 170,
                                                marginTop: 10,
                                                justifyContent: 'center',
                                            }}
                                        >
                                            Chọn tài liệu
                        </Button>
                                    </Col>
                                    <Col span={2} />
                                    <Col
                                        span={7}
                                        style={{ display: 'flex', flexDirection: 'column' }}
                                    >
                                        <text style={{ color: 'black', fontWeight: '600', fontSize: 15 }}>Đối tượng liên quan</text>
                                        <div>
                                            {this.props.ListCurrentObject.map(object => (
                                                <Tooltip
                                                    title={object.name}
                                                    placement="bottom"
                                                    key={object}
                                                >
                                                    <Avatar
                                                        shape="square"
                                                        size={64}
                                                        src={
                                                            object.avatar === ''
                                                                ? objectDefault
                                                                : object.avatar
                                                        }
                                                        style={{ margin: 10 }}
                                                    />
                                                </Tooltip>
                                            ))}
                                        </div>
                                        <Button
                                            type="primary"
                                            icon="upload"
                                            onClick={() => this.props.showModalObject(true)}
                                            style={{
                                                marginTop: 10,
                                                width: 170,
                                                justifyContent: 'center',
                                            }}
                                        >
                                            Chọn đối tượng
                        </Button>
                                    </Col>
                                </Row>
                                <GridContainer>
                                    <GridItem xs={12} sm={12} md={12}>
                                        <Card profile>
                                            <br />
                                            <InputLabel
                                                style={{
                                                    color:
                                                        this.state
                                                            .contentstate ===
                                                            'error'
                                                            ? 'red'
                                                            : 'black',
                                                    fontSize: 18,
                                                }}
                                            >
                                                Nội dung sự kiện: *
                                            </InputLabel>
                                            <CustomInput
                                                success={
                                                    this.state.contentstate ===
                                                    'success'
                                                }
                                                error={
                                                    this.state.contentstate ===
                                                    'error'
                                                }
                                                id="about-me"
                                                formControlProps={{
                                                    fullWidth: true,
                                                }}
                                                inputProps={{
                                                    placeholder:
                                                        'Nội dung của sự kiện',
                                                    onChange: e =>
                                                        this.setState({
                                                            content: e.target.value.trim(),
                                                        }),

                                                    multiline: true,
                                                    // rows: 10,
                                                }}
                                            />
                                        </Card>
                                    </GridItem>
                                </GridContainer>
                                <Button
                                    type="danger"
                                    className={classes.updateProfileButton}
                                    onClick={() => this.submitForm(lstTag)}
                                >
                                    Tạo sự kiện
                                </Button>
                                <Button
                                    type="primary"
                                    style={{ marginRight: 10 }}
                                    className={classes.updateProfileButton}
                                    onClick={() => this._handleAddExtendData()}
                                >
                                    Thêm trường dữ liệu
                                </Button>
                                <Clearfix />
                            </CardBody>
                        </Card>
                    </GridItem>
                </GridContainer>
                {this.props.VisibleModalMedia && (
                    <Modal
                        visible={true}
                        title="Lựa chọn tài liệu"
                        onOk={() => this.props.showModalMedia(false)}
                        onCancel={() => this.props.showModalMedia(false)}
                        centered
                        width={900}
                        footer={null}
                    >
                        <SelectMediaComponent
                            onSuccess={medias => this._userSelectMedia(medias)}
                            onCancel={() => this.props.showModalMedia(false)}
                            initMedia={this.props.ListCurrentMedia}
                        />
                    </Modal>
                )}
                {this.props.VisibleModalObject && (
                    <Modal
                        visible={true}
                        title="Lựa chọn đối tượng"
                        onOk={() => this.props.showModalObject(false)}
                        onCancel={() => this.props.showModalObject(false)}
                        width={900}
                        centered
                        footer={[]}
                    >
                        <SelectObjectComponent
                            onSuccess={objects =>
                                this._userSelectObject(objects)
                            }
                            onCancel={() => this.props.showModalObject(false)}
                            initObject={this.props.ListCurrentObject}
                        />
                    </Modal>
                )}
                {this.state.visible && (
                    <Modal
                        visible={true}
                        title="Thêm hash tag"
                        onOk={() => this._handleOK()}
                        onCancel={() => this.setState({ visible: false })}
                        centered
                        footer={[
                            <Button
                                key="submit"
                                size="large"
                                type="danger"
                                onClick={() => {
                                    this.setState({
                                        visible: false,
                                    })
                                    let temp = true
                                    lstTag.find(e => {
                                        if (e === this.state.TagAdd) {
                                            temp = false
                                        }
                                    })
                                    if (!temp) {
                                        notification.error({
                                            message: 'Hash tag này đã có',
                                        })
                                    } else {
                                        if (this.state.TagAdd.trim() !== '') {
                                            lstTag.push(this.state.TagAdd)
                                        }
                                    }
                                }}
                            >
                                Thêm
                            </Button>,
                        ]}
                    >
                        <CustomInput
                            formControlProps={{
                                fullWidth: true,
                            }}
                            onKeyDown={key => {
                                if (key.key === 'Enter') {
                                    this.setState({
                                        visible: false,
                                    })
                                    let temp = true
                                    lstTag.find(e => {
                                        if (e === this.state.TagAdd.trim()) {
                                            temp = false
                                        }
                                    })
                                    if (!temp) {
                                        notification.error({
                                            message: 'Hash tag này đã có',
                                        })
                                    } else {
                                        if (this.state.TagAdd.trim() !== '') {
                                            lstTag.push(this.state.TagAdd)
                                        }
                                    }
                                }
                            }}
                            isAutoFocus={true}
                            error={this.state.TagAdd.trim() === ''}
                            inputProps={{
                                onChange: event => {
                                    this.setState({
                                        TagAdd: event.target.value,
                                    })
                                },
                                multiline: true,

                            }}
                        />
                        {this.state.TagAdd.trim() === '' && (
                            <text style={{ color: 'red', fontSize: 14 }}>
                                Không được để trống
                            </text>
                        )}
                    </Modal>

                )}
            </div>
        )
    }
}

ContentCreateEvent.propTypes = {
    classes: PropTypes.object,
}
const mapStateToProps = state => {
    return {
        userInfo: state.auth.userInfo,
        currentEvent: state.eventReducer.currentEvent,
        ListCurrentMedia: state.scrumBoard.ListCurrentMedia,
        ListCurrentObject: state.scrumBoard.ListCurrentObject,
        VisibleModalMedia: state.scrumBoard.VisibleModalMedia,
        VisibleModalObject: state.scrumBoard.VisibleModalObject,

    }
}

const mapDispatchToProps = dispatch => {
    return {
        updateUserInfo: (uid, body) => {
            dispatch(authActions.action.updateUserInfo(uid, body))
        },
        createNewEvent: body => {
            dispatch(eventActions.action.createNewEvent(body))
        },
        showModalMedia: visible => {
            dispatch(scrumBoardActions.showModalMedia(visible))
        },
        showModalObject: visible => {
            dispatch(scrumBoardActions.showModalObject(visible))
        },
        applyToMedia: data => {
            dispatch(scrumBoardActions.applyToMedia(data))
        },
        applyToCurrentObject: data => {
            dispatch(scrumBoardActions.applyToCurrentObject(data))
        },
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withStyles(userProfileStyles)(ContentCreateEvent))
